var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWarning(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.2504 11.25C7.2504 11.4489 7.32941 11.6397 7.47007 11.7803C7.61072 11.921 7.80148 12 8.0004 12C8.19931 12 8.39007 11.921 8.53073 11.7803C8.67138 11.6397 8.7504 11.4489 8.7504 11.25C8.7504 11.0511 8.67138 10.8603 8.53073 10.7197C8.39007 10.579 8.19931 10.5 8.0004 10.5C7.80148 10.5 7.61072 10.579 7.47007 10.7197C7.32941 10.8603 7.2504 11.0511 7.2504 11.25V11.25ZM7.5004 6.5V9.375C7.5004 9.44375 7.55665 9.5 7.6254 9.5H8.3754C8.44415 9.5 8.5004 9.44375 8.5004 9.375V6.5C8.5004 6.43125 8.44415 6.375 8.3754 6.375H7.6254C7.55665 6.375 7.5004 6.43125 7.5004 6.5ZM14.9332 13.375L8.43321 2.125C8.33633 1.95781 8.16915 1.875 8.0004 1.875C7.83165 1.875 7.6629 1.95781 7.56758 2.125L1.06758 13.375C0.875396 13.7094 1.11602 14.125 1.5004 14.125H14.5004C14.8848 14.125 15.1254 13.7094 14.9332 13.375ZM2.69102 12.9391L8.0004 3.74844L13.3098 12.9391H2.69102V12.9391Z",
    fill: "#E61F37"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarning);
export default __webpack_public_path__ + "static/media/Warning.7d37588b595eefe5ec25d6b33573882c.svg";
export { ForwardRef as ReactComponent };